import { render, staticRenderFns } from "./ColunaSocio.vue?vue&type=template&id=0b71f9e4&scoped=true&"
import script from "./ColunaSocio.vue?vue&type=script&lang=js&"
export * from "./ColunaSocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71f9e4",
  null
  
)

export default component.exports